/**
 * @file Formats a phone number in its national or international form.
 */
import { parsePhoneNumber } from "awesome-phonenumber";

const US_REGION_CODE = "US";

/**
 * Formats the phone number in the national format for a US number, and in the
 * international format otherwise, or gives undefined for a number that is not valid.
 */
const formatPhoneNumber = (value?: string): string | undefined => {
  const { valid: isValid, number: phoneNumber, regionCode } = parsePhoneNumber(`+${value}`);

  if (!isValid) {
    return undefined;
  }

  const isUs = regionCode === US_REGION_CODE;

  const { international, national } = phoneNumber;

  const result = isUs
    ? national
    : international;

  return result;
};

export default formatPhoneNumber;
